import { type MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import CardPinnedUI from 'hb-react/frontoffice/apps/Forum/components/CardPinned/CardPinnedUI';
import {
  type Comments,
  type Likes,
  type User,
} from 'hb-react/frontoffice/components/CardForum/types';

export interface CardPinnedProps {
  comments: Pick<Comments, 'total'>;
  id: number;
  likes: Pick<Likes, 'count' | 'currentUserLiked' | 'id'>;
  title: string;
  user: User;
}

const CardPinned = ({ id, user, title, comments, likes }: CardPinnedProps) => {
  const navigate = useNavigate();

  const onClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    navigate(`t/${id}`);
  };

  return (
    <CardPinnedUI
      id={id}
      comments={comments}
      likes={likes}
      onClick={onClick}
      title={title}
      user={user}
    />
  );
};

export default CardPinned;
